/**
 * Publish the real viewport height as a CSS variable: `--app-height`.
 *
 * @remarks
 * The Android WebView shell returns `0` for `vh`/`dvh`/`svh` CSS units even
 * though `document.documentElement.clientHeight` is correct — so any element
 * sized with viewport units collapses to nothing (e.g. the container picker
 * drawer). Components that need a viewport-relative height use
 * `var(--app-height)` instead of `vh`. This works in the WebView (where `vh` is
 * broken) and in normal browsers (where `clientHeight` is equally correct).
 *
 * Updates on resize and orientation change (keyboard, rotation).
 */
function setAppHeight(): void {
  document.documentElement.style.setProperty(
    "--app-height",
    `${document.documentElement.clientHeight}px`,
  )
}

export function trackViewportHeight(): void {
  setAppHeight()
  window.addEventListener("resize", setAppHeight)
  window.addEventListener("orientationchange", setAppHeight)
}
